/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/adaptivity.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { adaptivityModule } from "../../../grids/grid_core/adaptivity/m_adaptivity";
import gridCore from "../m_core";
gridCore.registerModule("adaptivity", adaptivityModule);